module.exports = __webpack_public_path__ + "static/media/pepperony.7fa5c140.png";